export default __webpack_public_path__ + "static/media/Edit.429d49ea.svg";